module.exports = __webpack_public_path__ + "img/Phone_03.1b8d391f.jpg";